const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
export const stringify = (value, replacer = getCircularReplacer(), space = 2) => JSON.stringify(value, replacer, space);
export const transformArrayToQueryParams = (name, array) => {
    const separator = `&${name}=`;
    return `${name}=${array.join(separator)}`;
};
